import React from "react";
import styled from "styled-components";
import logo from "../../assets/images/logo.png";
import {device} from "../../assets/styles/media.js";
import Navigation from "../molecules/Navigation";
import TabletNav from "../molecules/TabletNav";
import {useNavigate} from "react-router-dom";

const Wrap = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #f6ac19;
    display: flex;
    z-index: 300;
    height: 80px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 100vw;
 
    box-sizing: border-box;

    ${device.mobile} {
        padding: 0 20px;
        height: 58px;
        overflow-x: hidden;

    }
`;

const Logo = styled.h1`
    cursor: pointer;
    padding-left: 60px;
    ${device.tablet} {
        padding-left: 30px;
    }
    ${device.mobile} {
        padding-left: 0;
    }
`;
const LogoImg = styled.img`
    width: 130px;
    height: auto;

    ${device.mobile} {
        padding-top: 5px;
        width: 90px;
    }
`;

const Header = ({isTablet}) => {
    const navigate = useNavigate();
    const menu = [
        {
            title: {name: "이용안내", url: "/guide"},
            sub: [
                {name: "관람 안내", url: "/guide"},
                {name: "요금 안내", url: "/guide/price"},
                {
                    name: "입장권 구매",
                    url: "https://map.naver.com/p/search/%EA%B0%95%EC%95%84%EC%A7%80%EC%88%B2/place/1806671210?lng=127.6620201&lat=37.7364351&placePath=/booking?bookingRedirectUrl=https://m.booking.naver.com/booking/5/bizes/434118?theme=place&entry=pll&area=pll&c=15.00,0,0,0,dh"
                },
                {name: "단체예약 안내", url: "/guide/group"},
                {name: "오시는 길", url: "/guide/location"}
            ]
        },
        {
            title: {name: "관람", url: "/map"},
            sub: [
                {name: "가이드맵", url: "/map"},
                {name: "네이처풀", url: "/map/naturepool"}
            ]
        },
        {
            title: {name: "프로그램", url: "/program"},
            sub: [
                {name: "강아지숲 박물관", url: "/program/museum"},
                {name: "상설 프로그램", url: "/program/permanent"},
                {name: "특별 프로그램", url: "/program/special"},
                {name: "도그 스포츠", url: "/program/dogsports"}
            ]
        }, {
            title: {name: "알림", url: "/notice"},
            sub: [
                {name: "공지", url: "/notice/announcement"},
                {name: "캠페인", url: "/notice/campaign"},
                {name: "강아지숲 이야기", url: "/notice/dstory"},
                {name: "자주하는 질문", url: "/notice/faq"}
            ]
        },
    ];
    return (
            <Wrap>
                    {/* 로고 */}
                    <Logo onClick={() => {
                        navigate("/");
                        window.scrollTo({top: 0, behavior: "smooth"});
                    }}>
                        <LogoImg src={logo} alt={"강아지숲"}/>
                    </Logo>
                    {/* 메뉴 */}
                    {!isTablet ?  <Navigation menu={menu}/> : <TabletNav menu={menu}/>}
            </Wrap>
    );
};

export default Header;
